export function filterObjectsByValue(arr, searchValue) {
    return arr.filter(obj => checkNested(obj, searchValue));
}

function checkNested(obj, searchValue) {
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            if (typeof obj[key] === "object" && obj[key] !== null) {
                if (checkNested(obj[key], searchValue)) {
                    return true;
                }
            } else if (typeof obj[key] === 'string' && obj[key].toString().toLowerCase().includes(searchValue.toLowerCase()) || typeof obj[key] === 'number' && obj[key].toString().toLowerCase().includes(searchValue.toLowerCase())) {
                return true;
            }
        }
    }
    return false;
}